import View from "../../../../View"
import {connect} from "../../../../redux/utils"
import {bindActionCreators} from 'redux'
import TableControls from '../../components/TableControls'
import {getSortedTimeZoneGroupsList, getSortedUserGroupsList, getSorting, getWordsFilter, getUsersFilter} from '../selectors'
import {changeSorting, changeUsersFilter, changeWordsFilter} from '../actions'
import {UserManagementConstants} from 'constants'
import {isUGREnabled, isTZGEnabled} from '../../../../features/selectors'
import WordsFilter from "../../components/WordsFilter";
import UsersFilter from '../../components/UsersFilter'
import {getUsersListForWorkAssignmentsTab} from '../../common/selectors'
import User from '../../../../store/User'
import {transformListToGroups} from '../../../../util/groupUtils'

export class TableControlsContainer extends View {
    constructor({
        changeSorting = () => {},
        changeUsersFilter = () => {},
        changeWordsFilter = () => {},
    }) {
        super(null)

        this.state = {
            sorting: {
                order: -1,
                asc: false,
            },
            usersFilter: {
                userIds: [],
                groupIds: [],
                groupType: null,
                allSelected: true,
            },
            wordsFilter: '',
            ugrEnabled: false,
            tzgEnabled: false,
            userGroupsList: null,
            timeZoneGroupsList: null,
            availableUsers: [],
        }

        this.params = {
            changeSorting,
            changeUsersFilter,
            changeWordsFilter,
        }

        this.onStatePropertyChanged('sorting', () => {
            this.tableControls.setState({
                sorting: this.state.sorting
            })
        })

        this.onAnyStatePropertyChanged(['ugrEnabled', 'tzgEnabled'], () => {
            this.tableControls.setState({
                showUserGroups: this.state.ugrEnabled,
                showTimeZoneGroups: this.state.tzgEnabled,
            })
        })

        this.onStatePropertyChanged('wordsFilter', () => {
            this.wordsFilter.setState({
                text: this.state.wordsFilter,
            })
        })

        this.onStateChanged(() => {
            this.usersFilter.setState({
                allSelected: this.state.usersFilter.allSelected,
                groupType: this.state.usersFilter.groupType,
                groupIds: this.state.usersFilter.groupIds,
                userIds: this.state.usersFilter.userIds,
                userGroups: this.state.ugrEnabled ? transformListToGroups(this.state.userGroupsList) : null,
                timeZoneGroups: this.state.tzgEnabled ? transformListToGroups(this.state.timeZoneGroupsList) : null,
                users: this.state.availableUsers.map(function(user) {
                    return new User(
                        user["id"],
                        user["firstName"],
                        user["lastName"],
                        user["middleInitial"],
                        user["username"],
                        user["activeInAT"] || user["enabled"],
                        false,
                        user["userGroupId"],
                        user["timeZoneGroupId"]
                    )
                })
            })
        })
    }

    afterRender() {
        this.usersFilter = new UsersFilter({
            onChange: this.params.changeUsersFilter,
            showInactiveCheckbox: false,
        })
        this.wordsFilter = new WordsFilter({onChange: this.params.changeWordsFilter})
        this.tableControls = new TableControls({
            usersFilterComponent: this.usersFilter,
            wordsFilterComponent: this.wordsFilter,
            onUserSortClick: this._handleUserSortClick,
            onUserGroupSortClick: this._handleUserGroupSortClick,
            onTimeZoneSortClick: this._handleTimeZoneGroupSortClick,
        }).init(this.$containerEl)
    }

    _handleSortingClick = (order) => {
        const orderChanged = order !== this.state.sorting.order
        this.params.changeSorting({
            order: order,
            asc: orderChanged ? true : !this.state.sorting.asc
        })
    }

    _handleUserSortClick = () => {
        this._handleSortingClick(UserManagementConstants.USER_LIST_ORDER_BY_NAME)
    }

    _handleUserGroupSortClick = () => {
        this._handleSortingClick(UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME)
    }

    _handleTimeZoneGroupSortClick = () => {
        this._handleSortingClick(UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME)
    }
}

export default connect(
    (state) => ({
        sorting: getSorting(state),
        ugrEnabled: isUGREnabled(state),
        tzgEnabled: isTZGEnabled(state),
        userGroupsList: getSortedUserGroupsList(state),
        timeZoneGroupsList: getSortedTimeZoneGroupsList(state),
        wordsFilter: getWordsFilter(state),
        usersFilter: getUsersFilter(state),
        availableUsers: getUsersListForWorkAssignmentsTab(state),
    }),
    (dispatch) => ({
        changeSorting: bindActionCreators(changeSorting, dispatch),
        changeUsersFilter: bindActionCreators(changeUsersFilter, dispatch),
        changeWordsFilter: bindActionCreators(changeWordsFilter, dispatch),
    })
)(TableControlsContainer)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/components/TableControlsContainer.js